export default __webpack_public_path__ + "static/media/kitchen-pack-4.5caa1e6b.png";